import { downloadCSV } from 'react-admin';
import jsonExport from 'jsonexport/dist';

export const courseCityDateExporter = async (records, fetchRelatedRecords) => {
  const courses = await fetchRelatedRecords(records, 'course', 'courses');
  const cities = await fetchRelatedRecords(records, 'city', 'cities');

  const data = records.map((record) => {
    const course = courses[record.course];
    const city = cities[record.city];

    return {
      'Course code': course?.code ?? '',
      'Course title': course?.title ?? course?.translations?.de?.title ?? '',
      Location: city?.name ?? '',
      Supplier: record.supplier ?? '',
      'Start date': record.startDate?.slice(0, 10) ?? '',
      'End date': record.endDate?.slice(0, 10) ?? '',
      Price: record.price ?? course?.basePrice ?? '',
      'Additional costs': record.additionalCosts ?? '',
    };
  });

  jsonExport(data, (error, csv) => {
    if (error) {
      throw error;
    }
    downloadCSV(csv, 'dates');
  });
};
